var t = /* @__PURE__ */ ((i) => (i.medium = "switch-md", i.large = "switch-lg", i))(t || {}), n = /* @__PURE__ */ ((i) => (i.primary = "switch-primary", i.secondary = "switch-secondary", i.info = "switch-info", i.warning = "switch-warning", i.alert = "switch-alert", i.success = "switch-success", i))(n || {});
function c(i) {
  const r = ["switch"];
  return i.error && r.push("switch-error"), i.disabled && r.push("switch-disabled"), i.size && r.push(t[i.size]), i.type && r.push(n[i.type]), r.join(" ");
}
export {
  t as SwitchSizes,
  n as SwitchTypeClasses,
  c as getSwitchStyleClasses
};
